import { IAuction } from '../../../../../redux/reducers';
import { ITermSchema } from '../../internalTypes';
import { mapAuctionStrategy } from './mapAuctionStrategy';
import { mapPeriod } from '../mapPeriod';
import { mapAuctionConfigurations } from './mapAuctionConfigurations';
import { mapAuctionServiceCosts } from './mapAuctionServiceCosts';

export function mapAuction(auctionTerm: ITermSchema | null): IAuction {
  const { auctionInfo, auctionStrategyInfo: rawStrategy, publishOptions, incompatibleServices, services, isAvailable } =
    auctionTerm || {};

  const { currentBet, maximalBet, minimalBet, configurations: rawConfigurations, serviceCosts: rawServiceCosts } =
    auctionInfo || {};

  const configurations = mapAuctionConfigurations(rawConfigurations);
  const serviceCosts = mapAuctionServiceCosts(rawServiceCosts);
  const strategy = mapAuctionStrategy(rawStrategy);

  const rawPeriods = publishOptions?.periods || [];
  const periods = rawPeriods.map(mapPeriod);

  return {
    isEnabled: !!auctionTerm && !!isAvailable,
    currentBet: currentBet || 0,
    minimalBet: minimalBet || 1,
    maximalBet: maximalBet || 99,
    services: services || [],
    incompatibleServices: incompatibleServices || [],
    configurations,
    serviceCosts,
    periods,
    strategy,
  };
}
